<template>
  <div class="language-screenshots">
    <!--    TODO: создавать загрузчики циклом for   -->

    <files-uploader
      class="phone"
      show-label
      mode="list"
      big-pictures
      :img-row="3"
      :files="initFiles.phone"
      can-picture-open>
      <template #icon>
        <i class="fa fa-mobile"/>
      </template>
      <template #label>
        <p class="label">
          {{ `${getFilesLabel()} ${$t('screenshots for phone')} ${languageItem.name} (${$t('size', {size: labelImg.phone})})` }}
        </p>
      </template>
    </files-uploader>

    <files-uploader
      class="table"
      show-label
      mode="list"
      big-pictures
      :img-row="3"
      :files="initFiles.table"
      can-picture-open>
      <template #icon>
        <i class="fa fa-tablet"/>
      </template>
      <template #label>
        <p class="label">
          {{ `${getFilesLabel()} ${$t('screenshots for tablet')} ${languageItem.name} (${$t('size', {size: labelImg.tablet})})` }}
        </p>
      </template>
    </files-uploader>

    <files-uploader
      class="screen"
      show-label
      mode="list"
      big-pictures
      :img-row="3"
      :files="initFiles.screen"
      can-picture-open>
      <template #icon>
        <el-icon>
          <Picture/>
        </el-icon>
      </template>
      <template #label>
        <p class="label">
          {{ `${getFilesLabel()} ${$t('screenshots for description')} ${languageItem.name} (${$t('size', {size: labelImg.descript})})` }}
        </p>
      </template>
    </files-uploader>

    <files-uploader
      class="icon"
      show-label
      :limit="1"
      mode="list"
      big-pictures
      :img-row="3"
      :files="initFiles.icon"
      can-picture-open>
      <template #icon>
        <el-icon>
          <PictureRounded/>
        </el-icon>
      </template>
      <template #label>
        <p class="label">
          {{ `${getFilesLabel(true)} ${languageItem.name} (${$t('size', {size: labelImg.icon})})` }}
        </p>
      </template>
    </files-uploader>
  </div>
</template>

<script>
import FilesUploader from '../../../UIComponents/Custom/FilesUploader'
import { mapGetters } from 'vuex'
import { IMG_STORE_SIZES, RESOLUTIONS_IMG_FIELDS } from '@/utils/constants'

export default {
  name: 'LanguageScreenshots',
  components: {
    FilesUploader
  },
  props: {
    languageItem: Object
  },
  data() {
    return {
      initFiles: {
        phone: [],
        table: [],
        screen: [],
        icon: []
      },
      imgResolutions: null
    }
  },
  computed: {
    ...mapGetters(['types', 'selectedApplication', 'selectedTask']),
    ...mapGetters({
      applications: 'creator/applications',
    }),
    appStore() {
      return this.types.app_store.find(store => store.id === this.selectedApplication.store_id).name
    },
    labelImg() {
      if (!this.imgResolutions) return IMG_STORE_SIZES[this.appStore]
      const aliasField = {
        phone_screen_resolution: 'phone',
        tablet_screen_resolution: 'tablet'
      }

      const cutomResolutions = Object.entries(this.imgResolutions)
        .reduce((prev, [key, value]) => {
          prev[aliasField[key]] = value
          return prev
        }, {})

      return {
        ...IMG_STORE_SIZES[this.appStore],
        ...cutomResolutions
      }
    }
  },
  methods: {
    getFilesLabel(oneFile = false) {
      return oneFile ? this.$t('Icon image') : this.$t('Images')
    },
    addCustomResolutions(selectTaskMeta) {
      const hasCustomResolution = Object.keys(selectTaskMeta)
        .some(item => ['phone_screen_resolution', 'tablet_screen_resolution'].includes(item))
      if (!hasCustomResolution) return
      this.imgResolutions = {}
      RESOLUTIONS_IMG_FIELDS.forEach(resolution => {
        if (selectTaskMeta[resolution.fieldModel] && selectTaskMeta[resolution.fieldModel] !== '1x1') {
          this.imgResolutions[resolution.fieldModel] = selectTaskMeta[resolution.fieldModel].replace(/x/, ' x ')
        }
      })
    }
  },
  beforeMount() {
    this.initFiles.phone = this.languageItem.phone_screenshot
    this.initFiles.table = this.languageItem.table_screenshot
    this.initFiles.screen = this.languageItem.screen
    this.initFiles.icon = [this.languageItem.icon]
    const selectTaskImgResolution = this.selectedApplication?.task
      ?.find(task => task.id === this.selectedTask.task.id)?.[this.selectedTask.type]?.settings
    if(selectTaskImgResolution) this.addCustomResolutions(selectTaskImgResolution)
  }
}
</script>

<style scoped>

</style>
